import { createSelector } from "@reduxjs/toolkit";
import {
  selectSessionsGroupedByYear,
  selectDeadlineForPeriod
} from "../../services/submissionPeriod/slices";
import { formatStartEnd, getEasternFormat } from "../../util/functions";

export const selectSessionInformation = createSelector(
  [selectSessionsGroupedByYear, (state, type, year) => year],
  (yearData, year) => {
    return yearData?.[year]?.sessions || [];
  }
);

export const selectChipsDetails = createSelector(
  [
    (state, year, period) =>
      selectDeadlineForPeriod(state, year, period, false),
  ],
  (deadline) => {
    if (!deadline) return [];

    const { lastModified: lastUpdated, lastModifiedBy: lastUpdateBy, year, calendarType, isActive, createdBy } =
      deadline;
    const lastUpdatedTime =
      lastUpdated &&
      getEasternFormat(lastUpdated, {
        month: "long",
        day: "numeric",
        year: "numeric",
      });

    return [
      { label: isActive ? "Active" : "", color: "info", variant: "contained" },
      { primary: `Year`, secondary: year },
      { primary: `Last Updated`, secondary: lastUpdatedTime },
      { primary: `Last Updated By`, secondary: lastUpdateBy },
      { primary: `Created By`, secondary: createdBy },
      { primary: `Session Type`, secondary: calendarType },
    ].filter((chip) => chip.label || chip.secondary);
  }
);

export const selectSessionLabel = createSelector(
  [
    (state, year, period) =>
      selectDeadlineForPeriod(state, year, period, false),
  ],
  (deadline) => {
    return deadline?.label
  }
);

export const selectDescriptionDetails = createSelector(
  [
    (state, year, period) =>
      selectDeadlineForPeriod(state, year, period, false),
  ],
  (deadline) => {
    if (!deadline) return [];

    const { description, start, end, formsCloseDate, formsOpenDate } =
      deadline;

    const reportingWindow = formatStartEnd({
      start,
      end,
      includeTime: true,
    });
    const formsOpenWindow = formatStartEnd({
      start: formsOpenDate,
      end: formsCloseDate,
      includeTime: true,
    });

    return [
        { label: "Description", value: description || "-" },
        { label: "Reporting Period", value: reportingWindow },
        { label: "Submissions Window", value: formsOpenWindow || "Not Yet Saved" },
      ]
  }
);


export const selectSubmissionPeriodsOptions = createSelector(
  [selectSessionsGroupedByYear],
  (yearData) =>
    Object.values(yearData).map(({ year, sessions = [] }) => ({
      year,
      isInitialized: !!sessions?.length,
    })).sort((a, b) => b.year - a.year)
);